import React, { useEffect, useRef, useState } from 'react';

const TimelineRowItem = ({ item, isFirst, isAbsoluteLast, isLastItemInGroup }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const isRight = item.align === 'right';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (ref.current) {
            observer.unobserve(ref.current);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div
      ref={ref}
      className={`relative flex flex-col pl-9 md:pl-0 ${isLastItemInGroup ? 'mb-0' : 'mb-12 md:mb-16'
        } ${isRight
          ? 'md:w-1/2 md:ml-auto md:pl-12 md:text-left'
          : 'md:w-1/2 md:mr-auto md:pr-12 md:text-right'
        }`}
    >
      <div
        className={`hidden md:block absolute w-[1px] transition-colors duration-500 ${isRight ? 'left-0 -translate-x-1/2' : 'right-0 translate-x-1/2'
          } ${isFirst ? 'top-2' : '-top-10 md:-top-16'} ${isAbsoluteLast ? 'bottom-0' : '-bottom-10 md:-bottom-16'
          } ${isVisible ? 'bg-[#2c231b]' : 'bg-[#83776966]'}`}
      ></div>

      <div
        className={`md:hidden absolute left-3 w-[1px] transition-colors duration-500 ${isFirst ? 'top-2' : '-top-10'
          } ${isAbsoluteLast ? 'bottom-0' : '-bottom-10'} ${isVisible ? 'bg-[#2c231b]' : 'bg-[#83776966]'
          }`}
      ></div>

      <div
        className={`hidden md:block absolute top-1.5 w-2.5 h-2.5 rounded-full ring-[8px] ring-[#f9f9f5] z-10 transition-colors duration-500 ${isRight ? 'left-0 -translate-x-1/2' : 'right-0 translate-x-1/2'
          } ${isVisible ? 'bg-[#2c231b]' : 'bg-[#83776966]'}`}
      ></div>

      <div
        className={`md:hidden absolute left-[7px] top-1.5 w-2.5 h-2.5 rounded-full ring-[8px] ring-[#f9f9f5] z-10 transition-colors duration-500 ${isVisible ? 'bg-[#2c231b]' : 'bg-[#83776966]'
          }`}
      ></div>

      <div
        className={`transition-opacity duration-[1000ms] ${isVisible ? 'opacity-100' : 'opacity-0'
          }`}
      >
        <span className="font-interDisplayMedium block uppercase font-normal font-arimo leading-[1.2] tracking-[0.1em] text-[14px] md:text-base mb-[23px]">
          {item.weeks}
        </span>
        <h3 className="font-saolDisplayItalic text-[28px] md:text-[42px] leading-[1.1] tracking-[0em] font-normal mb-[9px]">
          {item.title}
        </h3>
        <p className="font-interDisplayMedium leading-[1.6] tracking-[0.05em] text-[14px] md:text-base font-normal">
          {item.description}
        </p>
      </div>
    </div>
  );
};

export default TimelineRowItem;
